import { render, staticRenderFns } from "./DashRecordCard.vue?vue&type=template&id=a0619be4&"
import script from "./DashRecordCard.vue?vue&type=script&lang=js&"
export * from "./DashRecordCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports